var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 15.6,
    stroke: "#0464B2",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7961 12.4284C19.2618 11.9238 19.4947 11.6715 19.7421 11.5243C20.3392 11.1692 21.0744 11.1582 21.6815 11.4952C21.9331 11.6349 22.1731 11.8801 22.6531 12.3705C23.1332 12.8609 23.3733 13.1061 23.5099 13.3631C23.8399 13.9832 23.8291 14.7342 23.4814 15.3442C23.3374 15.597 23.0904 15.8349 22.5964 16.3106L16.7191 21.9714C15.7831 22.8731 15.315 23.3239 14.73 23.5523C14.1451 23.7808 13.502 23.764 12.2159 23.7304L12.0409 23.7258C11.6493 23.7156 11.4535 23.7104 11.3397 23.5813C11.2259 23.4521 11.2415 23.2527 11.2726 22.8539L11.2894 22.6373C11.3769 21.5147 11.4206 20.9534 11.6398 20.4489C11.859 19.9443 12.2372 19.5347 12.9934 18.7153L18.7961 12.4284Z",
    stroke: "#0464B2",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 12.5L22.5 16.875",
    stroke: "#0464B2",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.c58bb63224528a6ef9b4a788b7afb139.svg";
export { ForwardRef as ReactComponent };